import { PopulationDNDGrid } from '../shared/interfaces';
import { TEST_CHOICE_TYPES } from './choice-types';
import { TestAssociatedSuccessCriteria } from './test-associated-success-criteria.enum';

export const dndGrid: {
  [key: string]: PopulationDNDGrid;
} = {
  [TEST_CHOICE_TYPES.TEST_R_DND_GRID_1X6X4]: {
    question: {
      text: 'How many sounds are in the word - {TARGET_TEXT}. Drag the correct number of dots to represent the sounds. (verbal)',
      displayText:
        'How many sounds are in the word - {TARGET_TEXT}. Drag the correct number of dots to represent the sounds (visual).',
    },
    gridConfig: {
      rows: 1,
      columns: 6,
    },
    numAnswerChoices: 8,
    numCorrectAnswers: 4,
    labels: [{ text: '' }],
    answerChoices: [],
    answers: [],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.DRAG_AND_DROP],
  },
  [TEST_CHOICE_TYPES.TEST_R_DND_GRID_1X5X3]: {
    question: {
      text: 'How many sounds are in the word - {TARGET_TEXT}. Drag the correct number of dots to represent the sounds. (verbal)',
      displayText:
        'How many sounds are in the word - {TARGET_TEXT}. Drag the correct number of dots to represent the sounds (visual).',
    },
    gridConfig: {
      rows: 1,
      columns: 5,
    },
    numAnswerChoices: 6,
    numCorrectAnswers: 3,
    labels: [{ text: '' }],
    answerChoices: [],
    answers: [],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.DRAG_AND_DROP],
  },
};
